import React, { useCallback, useEffect } from "react"
import { array, object } from "yup"
import { useValidatorSeeker } from "@app"
import { AppOfficesAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { autoEuropePricingIdDrawerData, autoEuropePricingIdDrawerErrors } from "Pages/AutoEuropeTool/PricingId/@signals"

export default function AutoEuropePricingIdOfficeField() {
	const value = autoEuropePricingIdDrawerData.value.offices ?? []

	const { errors, isValid } = useValidatorSeeker({ offices: value }, object({
		offices: array().min(1, "At least one office is required"),
	}))

	useEffect(() => {
		autoEuropePricingIdDrawerErrors.value = { ...autoEuropePricingIdDrawerErrors.value, offices: isValid }
	}, [JSON.stringify(errors)])

	const onChange = useCallback((e) => {
		autoEuropePricingIdDrawerData.value = { ...autoEuropePricingIdDrawerData.value, offices: e.target.value }
	}, [])

	return <AppOfficesAutocomplete
		label="Offices"
		multiple
		urlAjax={`${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/offices`}
		value={(value ?? []).map(o => o?.value ?? o)}
		onChange={onChange}
		error={errors?.offices}
	/>
}